module.exports = __webpack_public_path__ + "img/horizontal_6_5_pp23_9006.2785cfea.png";